import React from "react";
import NotFound from "../Screens/Common/NotFound";
import Home from "../Screens/User/Home";
import CoursePage from "../Screens/User/CoursePage";
import Scod from "../Screens/User/Services/Scod";
import ImmigrationSupport from "../Screens/User/Services/ImmingrationSupport";
import PartnerWithUs from "../Screens/User/Contact/PartnerWithUs";
import RequestForService from "../Screens/User/Contact/RequestForService";
import Career from "../Screens/User/Contact/Career";
import FeedBack from "../Screens/User/Contact/FeedBack";
import Process from "../Screens/User/KnowledgeCenter/Process";
import RemoteBootCamp from "../Screens/User/Programs/RemoteBootCamp";
import AboutTechMentee from "../Screens/User/About/AboutTechMentee";
import Jobs from "../Screens/User/Contact/Jobs";
import Program from "../Screens/User/Programs/Program";
import ServiceRequest from "../Screens/User/Contact/ServiceRequest";
import CourseCategory from "../Screens/User/CourseCategory";
import CareerDetail from "../Screens/User/Contact/CareerDetail";
import Faq from "../Screens/User/Faq";
import HelpFaq from "../Components/Common/HelpFaq";
import PrivacyPolicy from "../Components/Common/PrivacyPolicy";
import ClockStopper from "../Screens/User/Programs/ClockStopper";
import HandsOnLearn from "../Screens/User/Programs/HandsOnLearn";
import EmployeShield from "../Screens/User/Programs/EmployeShield";
import Enrollment from "../Components/Common/Enrollment";
import CareerLauncher from "../Screens/User/Programs/CareerLauncher";
import ServiceDetails from "../Screens/User/Services/Servicedetails";
import CareerExplorer from "../Screens/User/Programs/Careerexplorer";

const userRoutes = [
  { path: "/", component: <Home /> },
  { path: "/courses", component: <CourseCategory /> },
  { path: "/faqs", component: <Faq /> },
  { path: "/course/:id", component: <CoursePage /> },
  { path: "*", component: <NotFound /> },
  { path: "/serviceDetails/:id", component: <ServiceDetails /> },
  { path: "/service/immigrationSupport", component: <ImmigrationSupport /> },
  { path: "/contact-us/partner-with-us", component: <PartnerWithUs /> },
  { path: "/contact-us/request-for-service", component: <RequestForService /> },
  { path: "/contact-us/feedback", component: <FeedBack /> },
  { path: "/contact-us/career", component: <Career /> },
  { path: "/contact-us/career/:title", component: <CareerDetail /> },
  { path: "/knowledge/process", component: <Process /> },
  { path: "/knowledge/program/remote-bootcamp", component: <RemoteBootCamp /> },
  // { path: "/knowledge/program/career-launcher", component: <CareerLauncher /> },
  {
    path: "/knowledge/program/career-explorer/clock-stopper",
    component: <ClockStopper />,
  },
  {
    path: "/knowledge/program/career-explorer",
    component: <CareerExplorer />,
  },
  {
    path: "/knowledge/program/career-explorer/hands-on-learn",
    component: <HandsOnLearn />,
  },
  {
    path: "/knowledge/program/career-explorer/employ-shield",
    component: <EmployeShield />,
  },
  { path: "/about/about-techmentee", component: <AboutTechMentee /> },
  { path: "/contact-us/career/jobs", component: <Jobs /> },
  { path: "/knowledge/program/:id", component: <Program /> },
  { path: "/serviceRequest", component: <ServiceRequest /> },
  { path: "/help-faqs", component: <HelpFaq /> },
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
  { path: "/enrollment", component: <Enrollment /> },
];

export { userRoutes };
